import React, { useState, useEffect, Fragment, useMemo } from 'react'
import { useHistory } from 'react-router';
import { valdiatePage } from '../../global';
import { reversepickupreport } from '../../services/reportservice';
import Loader from '../../images/whiteloader.svg';
import { accountsLocations, getMultipleSubAccountLocations } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';
import { useDispatch, useSelector } from 'react-redux';
import ExportExcelButton from "../../components/exportExcelButton";
import Pagination from '../../components/paginations';
import SeeMoreModal from '../../components/SeeMoreModal';


export const rprColumns = [
  { header: "Consigner Account No", key: "ConsignerAccountNo" },
  { header: "Account Name", key: "AccountName" },
  { header: "Location Name", key: "locationName" },
  { header: "Zone", key: "Zone" },
  { header: "Branch", key: "Branch" },
  { header: "Pickup Req Date", key: "PickupReqDate" },
  { header: "Order Ref No", key: "OrderRefNo" },
  { header: "Consignment Number", key: "ConsignmentNumber" },
  { header: "Customer Name", key: "CustomerName" },
  { header: "Customer Number", key: "CustomerNumber" },
  { header: "Shipper Address", key: "ShipperAddress" },
  { header: "Weight", key: "Weight" },
  { header: "Pieces", key: "Pieces" },
  { header: "Status", key: "Status" },
  { header: "Created Date", key: "CreatedDate" },
  { header: "Pickup Date", key: "PickupDate" },
  { header: "Pickup Address", key: "Address" },
  { header: "Delivery Date", key: "deliveryDate" },
  { header: "Product Description", key: "ProductDescription" },
  { header: "Remarks", key: "Remarks" },
];

const ReversePickupReport = () => {
    const dispatch = useDispatch();
    const { accounts, loading, userInfo, subaccounts } = useSelector(state => state.appData);
    const now = new Date();
    const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
    const month = `${now.getMonth() + 1}`;
    const year = `${now.getFullYear()}`;

    const history = useHistory();
    const d = {
        StartDate: today,
        EndDate: today,
        LocationID: [],
        Account: [accounts[1]],
        Status: '1',
        subAccountId:  []
    };

    const [data, setData] = useState(d);
    const [grid, setGrid] = useState([]);
    const [locations, setLocations] = useState([]);
    const [subAccountsLocal, setSubAccountsLocal] = useState([]);

    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    
    const searchObjInit = {
        Branch: '',
        ConsignmentNumber: ''
    };


    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });

    const gridKeys = [
        {key: 'ConsignerAccountNo', name: 'Account#', searchBox: false, visible: true},
        {key: 'AccountName', name: 'Account Name', searchBox: false, visible: true},
        {key: 'locationName', name: 'Location Name', searchBox: false, visible: true},
        {key: 'Zone', name: 'Zone', searchBox: false, visible: true},
        {key: 'Branch', name: 'Branch', searchBox: true, visible: true},
        {key: 'PickupReqDate', name: 'Pickup Req Date', searchBox: false, visible: true},
        {key: 'OrderRefNo', name: 'Order Ref#', searchBox: false, visible: true},
        {key: 'ConsignmentNumber', name: 'CN#', searchBox: true, visible: true},
        {key: 'CustomerName', name: 'Customer Name', searchBox: false, visible: true},
        {key: 'CustomerNumber', name: 'Customer Number', searchBox: false, visible: true},
        {key: 'Address', name: 'Pickup Address', searchBox: false, visible: true},
        {key: 'Weight', name: 'Weight', searchBox: false, visible: true},
        {key: 'Pieces', name: 'Pieces', searchBox: false, visible: true},
        {key: 'Status', name: 'Status', searchBox: false, visible: true},
        {key: 'CreatedDate', name: 'Created Date', searchBox: false, visible: true},
        {key: 'PickupDate', name: 'Pickup Date', searchBox: false, visible: true},
        {key: 'deliveryDate', name: 'Delivery Date', searchBox: false, visible: true},
        {key: 'ProductDescription', name: 'Product Details', searchBox: false, visible: true},
        {key: 'Remarks', name: 'Remarks', searchBox: false, visible: true}
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });


    useEffect(() => {
        if (!valdiatePage('/reversepickupreport')) {
            history.push('/login');
        }
        // if (data.Account) {
        //     getLocations(userInfo.id, data.Account).then(locs => {
        //         if (locs) {
        //             setLocations(locs);
        //             setData({ ...data, Account: data.Account, LocationID: locs.map(v => v.value).join() });
        //         }
        //     })
        // }
    }, []);

    const updateData = (key, val) => setData(prev => { return { ...prev, [key]: val } });

    const onSearch = async () => {

        if (!data.StartDate) {
            alert('Select Start Date');
            return;
        }
        if (!data.EndDate) {
            alert('Select End Date');
            return;
        }

        if (!data.Account || data.Account.length == 0) {
            alert('Select Account');
            return;
        }

        if (!data.LocationID || data.LocationID.length == 0) {
            alert('Select Location');
            return;
        }

        dispatch(setLoading({ data: true }));

        var rs = await reversepickupreport(data);

        dispatch(setLoading({ data: false }));

        if (rs.sts == 0) {
            if (rs.data.length > 0) {
                setGrid(rs.data);
                setOriginalGrid(rs.data);
            }
            else {
                alert('No Data Found');
                setGrid([]);
            }
        }
        else {
            alert(rs.msg);
            setGrid([]);
        }
    }

    useEffect(async () => {
        if (accounts.length > 0) {

            const subAccs = subaccounts.filter(e => e.accountNo.toUpperCase() === accounts[0].toUpperCase())

            setSubAccountsLocal(subAccs);

            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
            const d = { ...data, Account: [accounts[0]], subAccountId: [subAccs[0].id]};

            if (locs.length > 0) {
                d.LocationID = [+locs[0].value]
                setLocations(locs);
            }
            setData(d);

        }
    }, [])

    return userInfo &&
        <section className="section">
            <div className="section-header">
                <h1>Reverse Pickup Report</h1>
            </div>
            <div className="card" style={{ padding: 10 }}>
                <div className="row pb-2">
                    <div className="col">
                        <label>Account</label>
                        <select className="form-select" multiple value={data.Account} onChange={async (e) => {
                            let value = Array.from(e.target.selectedOptions, option => option.value);
                            let d = { ...data, Account: value };
                            if (value && value.length > 0) {
                                const subAccs = subaccounts.filter(e => value.includes(e.accountNo));
                                setSubAccountsLocal(subAccs);
                                const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
                                d.subAccountId =  [subAccs[0].id];
                    
                                if (locs.length > 0) {
                                    d.LocationID = [+locs[0].value]
                                    setLocations(locs);
                                } else {
                                    setLocations([]);
                                }
                            } else {
                                setLocations([]);
                            }
                            setData(d);
                        }}>
                            {
                                accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                            }
                        </select>
                    </div>

                    <div className="col-lg">
                        <label>Sub Account</label>
                        <select className="form-select" value={data.subAccountId} multiple onChange={async (e) => {
                            const selectedOptions = Array.from(e.target.selectedOptions);

                            const accnos = selectedOptions
                                .map(option => option.getAttribute('data-accno'))
                                .filter(acc => acc && acc.trim() !== '');
                    
                            const uniqueAccnos = Array.from(
                                new Map(accnos.map(acc => [acc.toLowerCase(), acc])).values()
                            );

                            const val = Array.from(new Set(
                                selectedOptions
                                    .map(option => option.value)
                                    .filter(v => v && !isNaN(v))
                                    .map(v => parseInt(v))
                            ));


                            console.log("Filtered SubAccount IDs:", val);
                            console.log("Unique Account Nos (data-accno):", uniqueAccnos);

                            const d = { ...data, subAccountId: val, Account: uniqueAccnos };
                            if (val) {
                                //d.isCod = e.target[e.target.selectedIndex].getAttribute('data-iscod') === 'true';
                                const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: val})
                                console.log(locs);
                                if (locs && locs.length > 0) {
                                    
                                    d.LocationID = [+locs[0].value]
                                    setLocations(locs);
                                } else {
                                    setLocations([]);
                                }
                            } else {
                                setLocations([]);
                                //d.isCod = null;
                            }
                            setData({ ...d});
                        }}>
                            <option value="" data-accno="" data-iscod="">Select Sub Account</option>
                            {
                                subAccountsLocal.map((x, index) => <option key={index} value={x.id} data-iscod={x.isCod} data-accno={x.accountNo}>{x.name}</option>)
                            }
                        </select>
                    </div>

                    <div className="col">
                        <label>Location</label>
                        <select className="form-select" multiple value={data.LocationID} onChange={async (e) => {
                            let val = Array.from(e.target.selectedOptions, option => +option.value);
                            setData({ ...data, LocationID: val });
                        }}>
                            {
                                locations.length > 0 && locations.map((x, index) => <option key={index} data-creditclientid={x.creditClientId} value={x.value}>{x.text}</option>)
                            }
                        </select>
                    </div>
                </div>


                <div className="row pb-2">
                    <div className="col">
                        <label>Start Date</label>
                        <input type="date" className="form-control" value={data.StartDate} onChange={(e) => updateData('StartDate', e.target.value)} />
                    </div>
                    <div className="col">
                        <label>End Date</label>
                        <input type="date" className="form-control" value={data.EndDate} onChange={(e) => updateData('EndDate', e.target.value)} />
                    </div>
                    <div className="col">
                        <label>Status</label>
                        <select type="date" className="form-select" value={data.Status} onChange={(e) => updateData('Status', e.target.value)}>
                            <option value="1">Booked</option>
                            <option value="2">Picked</option>
                            {/* <option value="3">Forwarded</option> */}
                            <option value="3">Delivered</option>
                        </select>
                    </div>
                    <div className="col">
                        <button type="button" className="btn btn-primary" disabled={loading} style={{ marginTop: '1.3rem', display : 'flex', placeSelf: 'self-end' }} onClick={onSearch}>
                            {loading ? <img src={Loader} height="30" /> : 'Search'}
                        </button>
                    </div>
                </div>
                {
                    originalGrid && originalGrid.length > 0 &&
                    <div className="row mt-3 pb-2">
                        <div className="col-12">
                            <div style={{ textAlign: 'right' }}>
                                {/* <ExportExcelRPR data={originalGrid} /> */}
                                  <ExportExcelButton data={originalGrid} columns={rprColumns} fileName="RPR_Report"
                                />
                            </div>
                            <br />

                            <Pagination
                                setGrid={setGrid}
                                searchObjInit={searchObjInit}
                                searchObject={searchObject}
                                originalGrid={originalGrid}
                                setPage={setPage}
                                setPageLimit={setPageLimit}
                                requestSort={requestSort}
                                sortConfig={sortConfig}
                                updateSearchData={updateSearchData}
                                sortedArray={sortedArray}
                                data={data}
                                dataCount={grid.length}
                                pageLimit={pageLimit}  
                                gridKeys={gridKeys}
                                page={page}
                                grid={
                                    sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                        <Fragment key={index}>
                                            <tr key={index}>
                                                <td>{(index + 1)+(page*pageLimit)}</td>
                                                <td>{x.ConsignerAccountNo}</td>
                                                <td style={{ minWidth: 200 }}>
                                                    <SeeMoreModal detail={x.AccountName} maxLength={80} />
                                                </td>
                                                <td style={{ minWidth: 200 }}>
                                                    <SeeMoreModal detail={x.locationName} maxLength={80} />
                                                </td>
                                                <td>{x.Zone}</td>
                                                <td>{x.Branch}</td>
                                                <td>{x.PickupReqDate}</td>
                                                <td>{x.OrderRefNo}</td>
                                                <td>{x.ConsignmentNumber}</td>
                                                <td>{x.CustomerName}</td>
                                                <td>{x.CustomerNumber}</td>
                                                <td style={{ minWidth: 300 }}>
                                                    <SeeMoreModal detail={x.Address} maxLength={80} />
                                                </td>
                                                <td>{x.Weight}</td>
                                                <td>{x.Pieces}</td>
                                                <td>{x.Status}</td>
                                                <td>{x.CreatedDate}</td>
                                                <td>{x.PickupDate}</td>
                                                <td>{x.deliveryDate}</td>
                                                <td style={{ minWidth: 300 }}>
                                                    <SeeMoreModal detail={x.ProductDescription} maxLength={80} />
                                                </td>
                                                <td style={{ minWidth: 300 }}>
                                                    <SeeMoreModal detail={x.Remarks} maxLength={80} />
                                                </td>
                                            </tr>
                                        </Fragment>
                                    )
                            }
                        />
                        </div>
                    </div>
                }
            </div>
        </section>
}

export default ReversePickupReport;